import React from 'react';

const DoctorBottomline = () => {
  const benefits = [
    {
      title: "Practice Optimization",
      description: "Strategic financial planning helps structure your practice for maximum profitability while balancing clinical quality, creating a sustainable model that serves both patients and your financial goals."
    },
    {
      title: "Accelerated Wealth Accumulation",
      description: "Specialized investment strategies designed for physicians' unique earning patterns can help overcome delayed career starts, allowing you to catch up and surpass traditional retirement benchmarks."
    },
    {
      title: "Liability Shield",
      description: "A comprehensive approach creates multiple layers of protection between professional liability exposure and personal assets, safeguarding your family's financial security regardless of practice challenges."
    },
    {
      title: "Work-Life Balance Enhancement",
      description: "Proper financial structures provide the freedom to make career decisions based on personal fulfillment and wellbeing rather than financial necessity, potentially reducing burnout risk throughout your career."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Physician-Focused Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DoctorBottomline;